"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getTimeout = exports.moduleInfoResolver = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isArray = _interopRequireDefault(require("./util/isArray"));

var _memo = _interopRequireDefault(require("./util/memo"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _config = {
  timeout: 5000
};
var absolutePath = /^(http(s)?:)?\/\//;

var isFiles = function isFiles(module) {
  return (0, _isArray.default)(module);
};

var string2Array = function string2Array() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return typeof str === 'string' ? [str] : str;
};

var resolveModule = function resolveModule(module) {
  if (typeof module === 'string') {
    return {
      js: [module]
    };
  } else if (isFiles(module)) {
    return {
      js: module
    };
  } else {
    return module;
  }
};

var i = 0;

var uid = function uid() {
  return '__mod_inner_anonymous_module_id_' + i++;
};

var moduleInfoResolver = (0, _memo.default)(function (module) {
  if (!module) return;
  var _config2 = _config,
      _config2$modules = _config2.modules,
      modules = _config2$modules === void 0 ? {} : _config2$modules,
      _config2$baseUrl = _config2.baseUrl,
      baseUrl = _config2$baseUrl === void 0 ? '' : _config2$baseUrl;
  var moduleInfo;

  if (typeof module === 'string') {
    if (modules.hasOwnProperty(module)) {
      moduleInfo = resolveModule(modules[module]);
    } else {
      moduleInfo = {
        js: [module],
        type: 'immediate'
      };
    }

    moduleInfo.key = module;
  } else if (isFiles(moduleInfo)) {
    moduleInfo = {
      key: moduleInfo.join('|'),
      js: moduleInfo,
      type: 'immediate'
    };
  } else {
    moduleInfo = _objectSpread({
      type: 'immediate'
    }, module);

    if (!moduleInfo.key && moduleInfo.type !== 'immediate') {
      var key = uid();
      moduleInfo.key = key;
    }
  }

  var _ref = moduleInfo,
      js = _ref.js,
      css = _ref.css,
      dep = _ref.dep;
  moduleInfo.js = string2Array(js).map(function (file) {
    return absolutePath.test(file) ? file : baseUrl + file;
  });
  moduleInfo.css = string2Array(css).map(function (file) {
    return absolutePath.test(file) ? file : baseUrl + file;
  });
  moduleInfo.dep = string2Array(dep);
  return moduleInfo;
});
exports.moduleInfoResolver = moduleInfoResolver;

var config = function config() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  _config = _objectSpread(_objectSpread(_objectSpread({}, _config), config), {}, {
    modules: _objectSpread(_objectSpread({}, _config.modules), config.modules)
  });
};

var getTimeout = function getTimeout() {
  return _config.timeout;
};

exports.getTimeout = getTimeout;
var _default = config;
exports.default = _default;
//# sourceMappingURL=config.js.map